import * as noUiSlider from 'nouislider'
import 'nouislider/dist/nouislider.css'


window.addEventListener('load', () => {
    const RangeSlider: any = document.querySelector(`[data-item="range-slider"]`)
    const RangeInputMin: any = document.querySelector(
        `[data-item="range-input-min"]`,
    )
    const RangeInputMax: any = document.querySelector(
        `[data-item="range-input-max"]`,
    )

    let RangeMinDefault: any = 0;
    let RangeMaxDefault: any = 100;

    if (RangeInputMin) {
        RangeMinDefault = RangeInputMin.getAttribute('data-default')
    }

    if (RangeInputMax) {
        RangeMaxDefault = RangeInputMax.getAttribute('data-default')
    }

    if (RangeSlider) {
        noUiSlider.create(RangeSlider, {
            start: [RangeMinDefault, RangeMaxDefault],
            step: 1000,
            connect: true,
            behaviour: 'drag',
            tooltips: true,
            range: {
                min: 0,
                max: 50000,
            },
            format: {
                // 'to' the formatted value. Receives a number.
                to: function (value) {
                    return Math.trunc(value) + ' m2'
                },
                // 'from' the formatted value.
                // Receives a string, should return a number.
                from: function (value) {
                    return Number(Math.trunc(parseFloat(value.replace(' m2', ''))))
                },
            },
        })

        mergeTooltips(RangeSlider, 25, ' - ');

        RangeSlider.noUiSlider.on('update', function (values: any, handle: any) {
            const value = values[handle]

            if (handle) {
                if (RangeInputMax) {
                    RangeInputMax.value = Number(
                        Math.trunc(parseFloat(value.replace(' m2', ''))),
                    )
                }
            } else {
                if (RangeInputMin) {
                    RangeInputMin.value = Number(
                        Math.trunc(parseFloat(value.replace(' m2', ''))),
                    )
                }
            }
        })
    }

    // hide loader
    window.setTimeout(() => {
        const loader = document.querySelector("[data-item='loader']")
        const loaderStyle = document.querySelector("[data-item='loader-styles']")

        if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader)
        }
        if (loaderStyle && loaderStyle.parentNode) {
            loaderStyle.parentNode.removeChild(loaderStyle)
        }
    }, 250)

    // Remove class that prevent transition
    const preload = document.querySelector('body')
    if (preload) {
        preload.classList.remove('preload')
    }

    function mergeTooltips(slider: any, threshold: any, separator: any) {

        var textIsRtl = getComputedStyle(slider).direction === 'rtl';
        var isRtl = slider.noUiSlider.options.direction === 'rtl';
        var isVertical = slider.noUiSlider.options.orientation === 'vertical';
        var tooltips = slider.noUiSlider.getTooltips();
        var origins = slider.noUiSlider.getOrigins();

        // Move tooltips into the origin element. The default stylesheet handles this.
        tooltips.forEach(function (tooltip: any, index: any) {
            if (tooltip) {
                origins[index].appendChild(tooltip);
            }
        });

        slider.noUiSlider.on('update', function (values: any, handle: any, unencoded: any, tap: any, positions: any) {

            var pools: any = [[]];
            var poolPositions: any = [[]];
            var poolValues: any = [[]];
            var atPool: any = 0;

            // Assign the first tooltip to the first pool, if the tooltip is configured
            if (tooltips[0]) {
                pools[0][0] = 0;
                poolPositions[0][0] = positions[0];
                poolValues[0][0] = values[0];
            }

            for (var i = 1; i < positions.length; i++) {
                if (!tooltips[i] || (positions[i] - positions[i - 1]) > threshold) {
                    atPool++;
                    pools[atPool] = [];
                    poolValues[atPool] = [];
                    poolPositions[atPool] = [];
                }

                if (tooltips[i]) {
                    pools[atPool].push(i);
                    poolValues[atPool].push(values[i]);
                    poolPositions[atPool].push(positions[i]);
                }
            }

            pools.forEach(function (pool: any, poolIndex: any) {
                var handlesInPool = pool.length;

                for (var j = 0; j < handlesInPool; j++) {
                    var handleNumber = pool[j];

                    if (j === handlesInPool - 1) {
                        var offset = 0;

                        poolPositions[poolIndex].forEach(function (value: any) {
                            offset += 1000 - value;
                        });

                        var direction = isVertical ? 'bottom' : 'right';
                        var last = isRtl ? 0 : handlesInPool - 1;
                        var lastOffset = 1000 - poolPositions[poolIndex][last];
                        offset = (textIsRtl && !isVertical ? 100 : 0) + (offset / handlesInPool) - lastOffset;

                        // Center this tooltip over the affected handles
                        tooltips[handleNumber].innerHTML = poolValues[poolIndex].join(separator);
                        tooltips[handleNumber].style.display = 'block';
                        tooltips[handleNumber].style[direction] = offset + '%';
                    } else {
                        // Hide this tooltip
                        tooltips[handleNumber].style.display = 'none';
                    }
                }
            });
        });
    }
})